import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { BoothApplicationsState } from '@/store/applications/booths/types'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const BoothApplications: Module<BoothApplicationsState, RootState> = {
  state: () => ({
    applications: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
}

export default BoothApplications
